import { render } from "./Expired.vue?vue&type=template&id=b599bdde&scoped=true"
import script from "./Expired.vue?vue&type=script&lang=js"
export * from "./Expired.vue?vue&type=script&lang=js"

import "./Expired.vue?vue&type=style&index=0&id=b599bdde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b599bdde"]])

export default __exports__